import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { StatementsProps } from './Statements.types'
import Link from 'components/shared/Link'
import { SPA_CONTRAINDICATIONS_STATEMENT } from 'constants/links'
import { StatementsWrapper, StyledValidationMessage } from './Statements.styles'
import Checkbox from 'components/shared/Checkbox'
import { useMemo } from 'react'
import { useResolutions } from 'store/resolutions'

export const Statements = ({
    isChecked,
    isError,
    isHollowError,
    onChange,
}: StatementsProps) => {
    const { isTablet } = useResolutions()

    // top margin considering space for validation message (to avoid layout 'jumping')
    const marginTop = useMemo(() => {
        // ! do not change margins before displaying validation at all
        if (!isError && !isHollowError) return undefined

        if (isTablet) return isError ? -8 : 40
        return isError ? -14 : 16
    }, [isTablet, isError, isHollowError])

    return (
        <StatementsWrapper gap={8} mt={marginTop}>
            {isError && (
                <StyledValidationMessage variant="body" color="error">
                    <FormattedMessage
                        id="upsells.wellness.treatment_contraindications_validation_message"
                        defaultMessage="_"
                    />
                </StyledValidationMessage>
            )}
            <Checkbox
                setIsChecked={onChange}
                isChecked={isChecked}
                testId="spa-check-contraindications-statement"
            >
                <Box mt={[4, 0]}>
                    <Text
                        variant="bodySmall"
                        color={isError ? 'error' : 'grayscale_900'}
                    >
                        <Text variant="bodySmall" color="error" as="span">
                            *
                        </Text>
                        <FormattedMessage
                            id="upsells.wellness.treatment_contraindications_statement"
                            defaultMessage="_"
                        />{' '}
                        <Link
                            variant="secondary"
                            textVariant="bodySmallStrong"
                            path={SPA_CONTRAINDICATIONS_STATEMENT}
                            icon={null}
                            target="_blank"
                            shouldStopPropagation
                            isUnderlined
                            data-testid="spa-link-contraindications-statement"
                        >
                            <FormattedMessage
                                id="upsells.wellness.treatment_contraindications_statement_link"
                                defaultMessage="Pełna treść oświadczenia"
                            />
                        </Link>
                    </Text>
                </Box>
            </Checkbox>
        </StatementsWrapper>
    )
}

Statements.displayName = 'Statements'
